<h3-comment-editor
  [commentStore]="samplingWorkspaceStore('workingCopy')('comment')"
  [samplingStore]="samplingWorkspaceStore('master')"
></h3-comment-editor>

@if (!enableNewSamplingNav) {
  <h3-sampling-controls pagePosition="footer"></h3-sampling-controls>
}

<h3-rejection-history
  *ngIf="showRejectionHistory$ | async"
></h3-rejection-history>
